import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from "./state/store";
import BootstrapVueNext from 'bootstrap-vue-next';
import VueApexCharts from "vue3-apexcharts";
import PhosphorIcons from "@phosphor-icons/vue";
import Wizard from 'form-wizard-vue3';
// import CoolLightBox from 'vue-cool-lightbox';
import './permission' //
// Packages CSS import
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import '@vueform/slider/themes/default.css';
import 'form-wizard-vue3/dist/form-wizard-vue3.css'
import 'simplebar-vue/dist/simplebar.min.css';
// bootstrap.bundle.js
import 'bootstrap/dist/js/bootstrap.bundle.js';

//antdesign
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
// 前端公共scss样式
import '@/assets/scss/common.scss'
//国际化多语言
import i18n from '@/i18n/index';
import dayjs from 'dayjs';

const app = createApp(App);
app.config.globalProperties.$dayjs = dayjs;
app.use(store)
    .use(router)
    .use(BootstrapVueNext)
    .use(VueApexCharts)
    .use(PhosphorIcons)
    .use(Antd)
    .use(i18n)
    // .use(CoolLightBox)
    .component('Wizard', Wizard)
    .mount('#app')